import { z } from 'zod';

export const OfferPeriodInquiryUnitSelectionSchema = z.object({
  unitId: z.string().min(1),
  periodIds: z.array(z.string().min(1)).min(1).max(200),
});
export type OfferPeriodInquiryUnitSelection = z.infer<typeof OfferPeriodInquiryUnitSelectionSchema>;

/** Request body for POST /offers/:id/period-inquiry */
export const OfferPeriodInquiryBodySchema = z.object({
  selection: z.array(OfferPeriodInquiryUnitSelectionSchema).min(1).max(200),
});
export type OfferPeriodInquiryBody = z.infer<typeof OfferPeriodInquiryBodySchema>;

/** Response schema (201, no significant body) */
export const OfferPeriodInquiryResponseSchema = z.object({});
export type OfferPeriodInquiryResponse = z.infer<typeof OfferPeriodInquiryResponseSchema>;
